/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpGameStateResponse } from './FuelUpGameStateResponse';
import {
    FuelUpGameStateResponseFromJSON,
    FuelUpGameStateResponseFromJSONTyped,
    FuelUpGameStateResponseToJSON,
    FuelUpGameStateResponseToJSONTyped,
} from './FuelUpGameStateResponse';

/**
 * 
 * @export
 * @interface FuelUpGameActionResponse
 */
export interface FuelUpGameActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpGameActionResponse
     */
    success: boolean;
    /**
     * 
     * @type {FuelUpGameStateResponse}
     * @memberof FuelUpGameActionResponse
     */
    gameState: FuelUpGameStateResponse;
    /**
     * Action result message
     * @type {string}
     * @memberof FuelUpGameActionResponse
     */
    message: string;
    /**
     * Fuel bonus for starting the game
     * @type {number}
     * @memberof FuelUpGameActionResponse
     */
    welcomeBonus?: number;
}

/**
 * Check if a given object implements the FuelUpGameActionResponse interface.
 */
export function instanceOfFuelUpGameActionResponse(value: object): value is FuelUpGameActionResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('gameState' in value) || value['gameState'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function FuelUpGameActionResponseFromJSON(json: any): FuelUpGameActionResponse {
    return FuelUpGameActionResponseFromJSONTyped(json, false);
}

export function FuelUpGameActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpGameActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'gameState': FuelUpGameStateResponseFromJSON(json['gameState']),
        'message': json['message'],
        'welcomeBonus': json['welcomeBonus'] == null ? undefined : json['welcomeBonus'],
    };
}

export function FuelUpGameActionResponseToJSON(json: any): FuelUpGameActionResponse {
    return FuelUpGameActionResponseToJSONTyped(json, false);
}

export function FuelUpGameActionResponseToJSONTyped(value?: FuelUpGameActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'gameState': FuelUpGameStateResponseToJSON(value['gameState']),
        'message': value['message'],
        'welcomeBonus': value['welcomeBonus'],
    };
}

